/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function t(t){const{attributes:l,sourceLayer:n}=t;if(!l||!n)return"";const e="displayField"in n?n.displayField:null,i=null!=e?l[e]:null,r=null!=i?i.toString():null,u=t.getObjectId()?.toString();return r||u||""}export{t as getFeatureTitle};
